import { useAtomValue } from 'jotai';

import { AdditionalOptionsMenu, AdditionalOptionsMenuProps } from '../../components/AdditionalOptionsMenu';
import { useGetClientSafetyGuard } from '../../useGetClientSafetyGuard';
import { useChatDrawerButtonUtils } from '../chat/useChatDrawerButtonUtils';
import { visitorMeasuresAtom } from '../state';

export function VisitorAdditionalOptionsMenuWrapper({ children }: Pick<AdditionalOptionsMenuProps, 'children'>) {
  const hasUnreadMessages = useChatDrawerButtonUtils().unreadMessagesCount > 0;
  const visitorMeasures = useAtomValue(visitorMeasuresAtom);
  const { requiresSafetyGuards } = useGetClientSafetyGuard();
  const hasOutstandingMeasures = !!visitorMeasures?.length;
  const shouldShowVisualIndicator = hasUnreadMessages || (hasOutstandingMeasures && requiresSafetyGuards === false);
  return (
    <AdditionalOptionsMenu shouldShowVisualIndicator={shouldShowVisualIndicator}>{children}</AdditionalOptionsMenu>
  );
}
